import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function UseRedefinirSenha() {
  const query = useQuery();
  const navigate = useNavigate();

  const uid = query.get("uid");
  const token = query.get("token");
  const [senha, setSenha] = useState("");
  const [repetir_senha, setRepetirSenha] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(null);

  const { setShowLoginModal } = useAuth();

  const validatePassword = (password) => {
    if (!password) {
      setError("");
      return;
    }
    if (password.length < 8) {
      setError("Senha deve ter pelo menos 8 caracteres");
      return;
    }
    if (!/[A-Z]/.test(password)) {
      setError("Senha deve conter 1 letra maiúscula");
      return;
    }
    if (!/[a-z]/.test(password)) {
      setError("Senha deve conter 1 letra minúscula");
      return;
    }
    if (!/[_.,*]/.test(password)) {
      setError('Senha deve conter um símbolo: "_", ",", ".", "*"');
      return;
    }

    return "";
  };

  const validateRepeatPassword = (password, repeatPassword) => {
    if (!repeatPassword) {
      setError("Senha é obrigatória");
      return;
    }
    if (!repeatPassword)
      if (!/[a-z]/.test(password)) {
        setError("Confirmação de senha é obrigatória");
        return;
      }
    if (password !== repeatPassword) {
      setError("As senhas não coincidem");
      return;
    }
    return "";
  };

  const enviarNovaSenha = async (senha, repetir_senha) => {
    try {
      setLoading(true);
      setError("");
      setSuccess("");

      const response = await fetch(`${API_URL}/api/auth/redefinir-senha/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid,
          token,
          password: senha,
          confirm_password: repetir_senha,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data?.detail || "Erro ao redefinir senha.");
      }

      setSuccess("Senha redefinida com sucesso!");
      setTimeout(() => {
        navigate("/");
        setShowLoginModal(true);
      }, 2000);
    } catch (err) {
      setError(err.message || "Erro inesperado.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    senha,
    setSenha,
    repetir_senha,
    setRepetirSenha,
    validatePassword,
    validateRepeatPassword,
    enviarNovaSenha,
    loading,
    error,
    setError,
    success,
    setSuccess,
  };
}
